import { render, staticRenderFns } from "./stuDetails.vue?vue&type=template&id=1975eaf2&"
import script from "./stuDetails.vue?vue&type=script&lang=js&"
export * from "./stuDetails.vue?vue&type=script&lang=js&"
import style0 from "./stuDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports